import { Measure } from '~/api/models/measure.model';

export const fake: Measure[] = [
    {
        date: 1669158000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -111.778198388681,
            port: 1,
            requested_nbrep: 1,
            rssi: -111,
            sf: 12,
            signal: -120.278198388681,
            snr: -8.5
        },
        values: {
            CO2: 635,
            CO2_alarm: 0,
            CO2_aqi: 27,
            SOC: 80,
            aqi: 27,
            humidity: 44,
            mslPressure: 984,
            pressure: 984,
            temperature: 21.45
        }
    },
    {
        date: 1669150800,
        rawValues: {},
        values: {
            CO2: 720,
            CO2_aqi: 33,
            aqi: 33
        }
    },
    {
        date: 1669143600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.48725660152233,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -122.48725660152233,
            snr: -7
        },
        values: {
            CO2: 847.1428571428571,
            CO2_alarm: 0,
            CO2_aqi: 40,
            SOC: 80,
            aqi: 40,
            humidity: 44,
            mslPressure: 983.5,
            pressure: 983.5,
            temperature: 22
        }
    },
    {
        date: 1669136400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.09677112370997,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -131.59677112370997,
            snr: -16.5
        },
        values: {
            CO2: 867.5,
            CO2_alarm: 0,
            CO2_aqi: 42,
            SOC: 80,
            aqi: 42,
            humidity: 44,
            mslPressure: 983,
            pressure: 983,
            temperature: 22.4
        }
    },
    {
        date: 1669129200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1,
            lora_version: 0,
            noise: -114.86222162551596,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -124.36222162551594,
            snr: -9.5
        },
        values: {
            CO2: 796.25,
            CO2_alarm: 0,
            CO2_aqi: 37,
            SOC: 80,
            aqi: 37,
            humidity: 44,
            mslPressure: 982,
            pressure: 982,
            temperature: 22.85
        }
    },
    {
        date: 1669122000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -114.6481805651168,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -131.3981805651168,
            snr: -16.75
        },
        values: {
            CO2: 773.75,
            CO2_alarm: 0,
            CO2_aqi: 36,
            SOC: 80,
            aqi: 36,
            humidity: 44,
            mslPressure: 982.5,
            pressure: 982.5,
            temperature: 23.450000000000003
        }
    },
    {
        date: 1669114800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -114.01439158009941,
            port: 1,
            requested_nbrep: 1,
            rssi: -113.5,
            sf: 12,
            signal: -124.51439158009941,
            snr: -10.5
        },
        values: {
            CO2: 575,
            CO2_alarm: 0,
            CO2_aqi: 22,
            SOC: 80,
            aqi: 22,
            humidity: 44,
            mslPressure: 983,
            pressure: 983,
            temperature: 24.25
        }
    },
    {
        date: 1669107600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -115.6864055992109,
            port: 1,
            requested_nbrep: 1,
            rssi: -115.5,
            sf: 12,
            signal: -129.4364055992109,
            snr: -13.75
        },
        values: {
            CO2: 460,
            CO2_alarm: 0,
            CO2_aqi: 8,
            SOC: 80,
            aqi: 8,
            humidity: 44.5,
            mslPressure: 983,
            pressure: 983,
            temperature: 25.1
        }
    },
    {
        date: 1669100400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -115.08721101528002,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -124.08721101528002,
            snr: -9
        },
        values: {
            CO2: 465,
            CO2_alarm: 0,
            CO2_aqi: 8,
            SOC: 80,
            aqi: 8,
            humidity: 45,
            mslPressure: 982,
            pressure: 982,
            temperature: 25.05
        }
    },
    {
        date: 1669093200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -115.3041898109243,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -126.8041898109243,
            snr: -11.5
        },
        values: {
            CO2: 477.5,
            CO2_alarm: 0,
            CO2_aqi: 10,
            SOC: 80,
            aqi: 10,
            humidity: 45.5,
            mslPressure: 981,
            pressure: 981,
            temperature: 24.95
        }
    },
    {
        date: 1669086000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.1492592375159,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -130.6492592375159,
            snr: -15.5
        },
        values: {
            CO2: 490,
            CO2_alarm: 0,
            CO2_aqi: 11,
            SOC: 80,
            aqi: 11,
            humidity: 46,
            mslPressure: 980,
            pressure: 980,
            temperature: 24.85
        }
    },
    {
        date: 1669078800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -114.87944887491776,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -125.37944887491776,
            snr: -10.5
        },
        values: {
            CO2: 516.25,
            CO2_alarm: 0,
            CO2_aqi: 15,
            SOC: 80,
            aqi: 15,
            humidity: 46,
            mslPressure: 980,
            pressure: 980,
            temperature: 24.65
        }
    },
    {
        date: 1669071600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -111.24177401756185,
            port: 1,
            requested_nbrep: 1,
            rssi: -111,
            sf: 12,
            signal: -127.49177401756184,
            snr: -16.25
        },
        values: {
            CO2: 570,
            CO2_alarm: 0,
            CO2_aqi: 21,
            SOC: 80,
            aqi: 21,
            humidity: 46,
            mslPressure: 979,
            pressure: 979,
            temperature: 24.35
        }
    },
    {
        date: 1669064400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1,
            lora_version: 0,
            noise: -113.2376019773414,
            port: 1,
            requested_nbrep: 1,
            rssi: -113,
            sf: 12,
            signal: -125.7376019773414,
            snr: -12.5
        },
        values: {
            CO2: 648,
            CO2_alarm: 0,
            CO2_aqi: 28,
            SOC: 80,
            aqi: 28,
            humidity: 47,
            mslPressure: 979,
            pressure: 979,
            temperature: 24.2
        }
    },
    {
        date: 1669057200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -115.63405841214946,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.13405841214944,
            snr: -9.5
        },
        values: {
            CO2: 842.8571428571429,
            CO2_alarm: 0,
            CO2_aqi: 40,
            SOC: 80,
            aqi: 40,
            humidity: 47,
            mslPressure: 978,
            pressure: 978,
            temperature: 23.700000000000003
        }
    },
    {
        date: 1669050000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -113.1819033925673,
            port: 1,
            requested_nbrep: 1,
            rssi: -113,
            sf: 12,
            signal: -126.9319033925673,
            snr: -13.75
        },
        values: {
            CO2: 870,
            CO2_alarm: 0,
            CO2_aqi: 42,
            SOC: 80,
            aqi: 42,
            humidity: 47.5,
            mslPressure: 979,
            pressure: 979,
            temperature: 23.15
        }
    },
    {
        date: 1669042800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.15142276599207,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -129.65142276599207,
            snr: -14.5
        },
        values: {
            CO2: 900,
            CO2_alarm: 0,
            CO2_aqi: 44,
            SOC: 80,
            aqi: 44,
            humidity: 48,
            mslPressure: 980,
            pressure: 980,
            temperature: 22.7
        }
    },
    {
        date: 1669035600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -115.70800870574796,
            port: 1,
            requested_nbrep: 1,
            rssi: -115.5,
            sf: 12,
            signal: -130.85800870574798,
            snr: -15.15
        },
        values: {
            CO2: 978.5714285714286,
            CO2_alarm: 0,
            CO2_aqi: 49,
            SOC: 80,
            aqi: 49,
            humidity: 48.5,
            mslPressure: 982.5,
            pressure: 982.5,
            temperature: 21.4
        }
    },
    {
        date: 1669028400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1,
            lora_version: 0,
            noise: -115.09615408440142,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -131.5961540844014,
            snr: -16.5
        },
        values: {
            CO2: 814,
            CO2_alarm: 0,
            CO2_aqi: 38,
            SOC: 80,
            aqi: 38,
            humidity: 48,
            mslPressure: 984,
            pressure: 984,
            temperature: 20.1
        }
    },
    {
        date: 1669021200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -114.69451237166673,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -128.19451237166675,
            snr: -13.5
        },
        values: {
            CO2: 454.2857142857143,
            CO2_alarm: 0,
            CO2_aqi: 7,
            SOC: 80,
            aqi: 7,
            humidity: 48,
            mslPressure: 988,
            pressure: 988,
            temperature: 19.6
        }
    },
    {
        date: 1669014000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -114.43544191454478,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -124.43544191454478,
            snr: -10
        },
        values: {
            CO2: 450,
            CO2_alarm: 0,
            CO2_aqi: 6,
            SOC: 80,
            aqi: 6,
            humidity: 48,
            mslPressure: 990.5,
            pressure: 990.5,
            temperature: 19.75
        }
    },
    {
        date: 1669006800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.15142276599207,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -129.65142276599207,
            snr: -14.5
        },
        values: {
            CO2: 457.5,
            CO2_alarm: 0,
            CO2_aqi: 7,
            SOC: 80,
            aqi: 7,
            humidity: 48,
            mslPressure: 993,
            pressure: 993,
            temperature: 19.8
        }
    },
    {
        date: 1668999600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -112.88586751209289,
            port: 1,
            requested_nbrep: 1,
            rssi: -112.5,
            sf: 12,
            signal: -125.88586751209287,
            snr: -13
        },
        values: {
            CO2: 470,
            CO2_alarm: 0,
            CO2_aqi: 9,
            SOC: 80,
            aqi: 9,
            humidity: 48,
            mslPressure: 994.5,
            pressure: 994.5,
            temperature: 19.9
        }
    },
    {
        date: 1668992400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.29706163635328,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -126.79706163635328,
            snr: -11.5
        },
        values: {
            CO2: 487.5,
            CO2_alarm: 0,
            CO2_aqi: 11,
            SOC: 80,
            aqi: 11,
            humidity: 48,
            mslPressure: 996,
            pressure: 996,
            temperature: 19.9
        }
    },
    {
        date: 1668985200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -115.26733180684734,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -127.26733180684734,
            snr: -12
        },
        values: {
            CO2: 488.75,
            CO2_alarm: 0,
            CO2_aqi: 11,
            SOC: 80,
            aqi: 11,
            humidity: 48,
            mslPressure: 996,
            pressure: 996,
            temperature: 20
        }
    },
    {
        date: 1668978000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -112.67720279985085,
            port: 1,
            requested_nbrep: 1,
            rssi: -112.5,
            sf: 12,
            signal: -127.32720279985085,
            snr: -14.65
        },
        values: {
            CO2: 465,
            CO2_alarm: 0,
            CO2_aqi: 8,
            SOC: 80,
            aqi: 8,
            humidity: 48,
            mslPressure: 995.5,
            pressure: 995.5,
            temperature: 20
        }
    },
    {
        date: 1668970800,
        rawValues: {},
        values: {
            CO2: 450,
            CO2_aqi: 6,
            aqi: 6
        }
    },
    {
        date: 1668963600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 5,
            lora_version: 0,
            noise: -114.18978441047734,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -127.68978441047734,
            snr: -13.5
        },
        values: {
            CO2: 433.3333333333333,
            CO2_alarm: 0,
            CO2_aqi: 4,
            SOC: 80,
            aqi: 4,
            humidity: 48,
            mslPressure: 993,
            pressure: 993,
            temperature: 20.2
        }
    },
    {
        date: 1668956400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -113.18680634183168,
            port: 1,
            requested_nbrep: 1,
            rssi: -113,
            sf: 12,
            signal: -127.68680634183168,
            snr: -14.5
        },
        values: {
            CO2: 440,
            CO2_alarm: 0,
            CO2_aqi: 5,
            SOC: 80,
            aqi: 5,
            humidity: 48.5,
            mslPressure: 993,
            pressure: 993,
            temperature: 20.15
        }
    },
    {
        date: 1668949200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -114.74342302341532,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -127.24342302341532,
            snr: -12.5
        },
        values: {
            CO2: 448.75,
            CO2_alarm: 0,
            CO2_aqi: 6,
            SOC: 80,
            aqi: 6,
            humidity: 49,
            mslPressure: 995,
            pressure: 995,
            temperature: 20.05
        }
    },
    {
        date: 1668942000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -114.71081852649533,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -122.21081852649533,
            snr: -7.5
        },
        values: {
            CO2: 465,
            CO2_alarm: 0,
            CO2_aqi: 8,
            SOC: 80,
            aqi: 8,
            humidity: 49,
            mslPressure: 996,
            pressure: 996,
            temperature: 20
        }
    },
    {
        date: 1668934800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.2376019773414,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -127.7376019773414,
            snr: -12.5
        },
        values: {
            CO2: 480,
            CO2_alarm: 0,
            CO2_aqi: 10,
            SOC: 80,
            aqi: 10,
            humidity: 49,
            mslPressure: 995.5,
            pressure: 995.5,
            temperature: 20.05
        }
    },
    {
        date: 1668927600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.45457919624153,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.30457919624152,
            snr: -9.85
        },
        values: {
            CO2: 496.25,
            CO2_alarm: 0,
            CO2_aqi: 12,
            SOC: 80,
            aqi: 12,
            humidity: 49,
            mslPressure: 995,
            pressure: 995,
            temperature: 20.1
        }
    },
    {
        date: 1668920400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.29706163635328,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -126.79706163635328,
            snr: -11.5
        },
        values: {
            CO2: 496.25,
            CO2_alarm: 0,
            CO2_aqi: 12,
            SOC: 80,
            aqi: 12,
            humidity: 49,
            mslPressure: 995,
            pressure: 995,
            temperature: 20.15
        }
    },
    {
        date: 1668913200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 5,
            lora_version: 0,
            noise: -115.41630687899472,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.41630687899472,
            snr: -10
        },
        values: {
            CO2: 471.25,
            CO2_alarm: 0,
            CO2_aqi: 9,
            SOC: 80,
            aqi: 9,
            humidity: 49,
            mslPressure: 995,
            pressure: 995,
            temperature: 20.2
        }
    },
    {
        date: 1668906000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.26110020524963,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -127.76110020524963,
            snr: -12.5
        },
        values: {
            CO2: 456.25,
            CO2_alarm: 0,
            CO2_aqi: 7,
            SOC: 80,
            aqi: 7,
            humidity: 49,
            mslPressure: 994,
            pressure: 994,
            temperature: 20.3
        }
    },
    {
        date: 1668898800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -113.3707776445072,
            port: 1,
            requested_nbrep: 1,
            rssi: -113,
            sf: 12,
            signal: -123.8707776445072,
            snr: -10.5
        },
        values: {
            CO2: 450,
            CO2_alarm: 0,
            CO2_aqi: 6,
            SOC: 80,
            aqi: 6,
            humidity: 49,
            mslPressure: 994,
            pressure: 994,
            temperature: 20.4
        }
    },
    {
        date: 1668891600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.16954289279533,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -129.16954289279533,
            snr: -14
        },
        values: {
            CO2: 450,
            CO2_alarm: 0,
            CO2_aqi: 6,
            SOC: 80,
            aqi: 6,
            humidity: 49,
            mslPressure: 994,
            pressure: 994,
            temperature: 20.5
        }
    },
    {
        date: 1668884400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.18978441047734,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -128.68978441047733,
            snr: -13.5
        },
        values: {
            CO2: 450,
            CO2_alarm: 0,
            CO2_aqi: 6,
            SOC: 80,
            aqi: 6,
            humidity: 50,
            mslPressure: 993,
            pressure: 993,
            temperature: 20.6
        }
    },
    {
        date: 1668877200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4.5,
            lora_version: 0,
            noise: -115.33982530377163,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -126.33982530377163,
            snr: -11
        },
        values: {
            CO2: 450,
            CO2_alarm: 0,
            CO2_aqi: 6,
            SOC: 80,
            aqi: 6,
            humidity: 50,
            mslPressure: 991.5,
            pressure: 991.5,
            temperature: 20.7
        }
    },
    {
        date: 1668870000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.15551081436612,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -129.55551081436613,
            snr: -14.4
        },
        values: {
            CO2: 453.75,
            CO2_alarm: 0,
            CO2_aqi: 7,
            SOC: 80,
            aqi: 7,
            humidity: 50,
            mslPressure: 990.5,
            pressure: 990.5,
            temperature: 20.7
        }
    },
    {
        date: 1668862800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1,
            lora_version: 0,
            noise: -115.3707776445072,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.8707776445072,
            snr: -10.5
        },
        values: {
            CO2: 466,
            CO2_alarm: 0,
            CO2_aqi: 8,
            SOC: 80,
            aqi: 8,
            humidity: 50,
            mslPressure: 990,
            pressure: 990,
            temperature: 20.6
        }
    },
    {
        date: 1668855600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -115.62406901935698,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -124.12406901935698,
            snr: -8.5
        },
        values: {
            CO2: 494.2857142857143,
            CO2_alarm: 0,
            CO2_aqi: 12,
            SOC: 80,
            aqi: 12,
            humidity: 50,
            mslPressure: 991,
            pressure: 991,
            temperature: 20.6
        }
    },
    {
        date: 1668848400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -113.8258102619798,
            port: 1,
            requested_nbrep: 1,
            rssi: -113.5,
            sf: 12,
            signal: -125.3258102619798,
            snr: -11.5
        },
        values: {
            CO2: 518.75,
            CO2_alarm: 0,
            CO2_aqi: 15,
            SOC: 80,
            aqi: 15,
            humidity: 50,
            mslPressure: 990,
            pressure: 990,
            temperature: 20.65
        }
    },
    {
        date: 1668841200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.54079808550127,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -124.54079808550127,
            snr: -9
        },
        values: {
            CO2: 543.75,
            CO2_alarm: 0,
            CO2_aqi: 18,
            SOC: 80,
            aqi: 18,
            humidity: 50,
            mslPressure: 990,
            pressure: 990,
            temperature: 20.7
        }
    },
    {
        date: 1668834000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -113.69451237166673,
            port: 1,
            requested_nbrep: 1,
            rssi: -113.5,
            sf: 12,
            signal: -127.19451237166673,
            snr: -13.5
        },
        values: {
            CO2: 550,
            CO2_alarm: 0,
            CO2_aqi: 19,
            SOC: 80,
            aqi: 19,
            humidity: 50,
            mslPressure: 988.5,
            pressure: 988.5,
            temperature: 20.8
        }
    },
    {
        date: 1668826800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.2376019773414,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -127.7376019773414,
            snr: -12.5
        },
        values: {
            CO2: 533.75,
            CO2_alarm: 0,
            CO2_aqi: 17,
            SOC: 80,
            aqi: 17,
            humidity: 50,
            mslPressure: 988.5,
            pressure: 988.5,
            temperature: 20.85
        }
    },
    {
        date: 1668819600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.3707776445072,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.8707776445072,
            snr: -10.5
        },
        values: {
            CO2: 530,
            CO2_alarm: 0,
            CO2_aqi: 16,
            SOC: 80,
            aqi: 16,
            humidity: 50,
            mslPressure: 989,
            pressure: 989,
            temperature: 20.9
        }
    },
    {
        date: 1668812400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.45030146848634,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.95030146848633,
            snr: -10.5
        },
        values: {
            CO2: 557.1428571428571,
            CO2_alarm: 0,
            CO2_aqi: 20,
            SOC: 80,
            aqi: 20,
            humidity: 50,
            mslPressure: 989,
            pressure: 989,
            temperature: 21
        }
    },
    {
        date: 1668805200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1,
            lora_version: 0,
            noise: -114.26572375596102,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -126.26572375596102,
            snr: -12
        },
        values: {
            CO2: 592,
            CO2_alarm: 0,
            CO2_aqi: 24,
            SOC: 80,
            aqi: 24,
            humidity: 50,
            mslPressure: 989,
            pressure: 989,
            temperature: 21.1
        }
    },
    {
        date: 1668798000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -114.11050460669037,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -130.11050460669037,
            snr: -16
        },
        values: {
            CO2: 645.7142857142857,
            CO2_alarm: 0,
            CO2_aqi: 28,
            SOC: 80,
            aqi: 28,
            humidity: 50,
            mslPressure: 988,
            pressure: 988,
            temperature: 21.2
        }
    },
    {
        date: 1668790800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -113.37944887491776,
            port: 1,
            requested_nbrep: 1,
            rssi: -113,
            sf: 12,
            signal: -123.87944887491776,
            snr: -10.5
        },
        values: {
            CO2: 636.25,
            CO2_alarm: 0,
            CO2_aqi: 27,
            SOC: 80,
            aqi: 27,
            humidity: 50,
            mslPressure: 987,
            pressure: 987,
            temperature: 21.2
        }
    },
    {
        date: 1668783600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -114.26572375596102,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -126.26572375596102,
            snr: -12
        },
        values: {
            CO2: 632.5,
            CO2_alarm: 0,
            CO2_aqi: 27,
            SOC: 80,
            aqi: 27,
            humidity: 50,
            mslPressure: 987,
            pressure: 987,
            temperature: 21.1
        }
    },
    {
        date: 1668776400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -114.49387452215927,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -123.74387452215927,
            snr: -9.25
        },
        values: {
            CO2: 592.5,
            CO2_alarm: 0,
            CO2_aqi: 24,
            SOC: 80,
            aqi: 24,
            humidity: 50,
            mslPressure: 988,
            pressure: 988,
            temperature: 21.05
        }
    },
    {
        date: 1668769200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -115.71081852649533,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -123.21081852649533,
            snr: -7.5
        },
        values: {
            CO2: 548,
            CO2_alarm: 0,
            CO2_aqi: 19,
            SOC: 80,
            aqi: 19,
            humidity: 50,
            mslPressure: 989,
            pressure: 989,
            temperature: 21
        }
    },
    {
        date: 1668762000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -114.80662943973715,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -126.80662943973715,
            snr: -12
        },
        values: {
            CO2: 528.5714285714286,
            CO2_alarm: 0,
            CO2_aqi: 16,
            SOC: 80,
            aqi: 16,
            humidity: 50,
            mslPressure: 987.5,
            pressure: 987.5,
            temperature: 21
        }
    },
    {
        date: 1668754800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.18978441047734,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -128.68978441047733,
            snr: -13.5
        },
        values: {
            CO2: 548,
            CO2_alarm: 0,
            CO2_aqi: 19,
            SOC: 80,
            aqi: 19,
            humidity: 50,
            mslPressure: 986,
            pressure: 986,
            temperature: 21.1
        }
    },
    {
        date: 1668747600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -114.76110020524963,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -127.26110020524963,
            snr: -12.5
        },
        values: {
            CO2: 544.2857142857143,
            CO2_alarm: 0,
            CO2_aqi: 18,
            SOC: 80,
            aqi: 18,
            humidity: 50,
            mslPressure: 984.5,
            pressure: 984.5,
            temperature: 21.2
        }
    },
    {
        date: 1668740400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.5039400814243,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.0039400814243,
            snr: -9.5
        },
        values: {
            CO2: 548.75,
            CO2_alarm: 0,
            CO2_aqi: 19,
            SOC: 80,
            aqi: 19,
            humidity: 50,
            mslPressure: 983.5,
            pressure: 983.5,
            temperature: 21.25
        }
    },
    {
        date: 1668733200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -115.3041898109243,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -126.8041898109243,
            snr: -11.5
        },
        values: {
            CO2: 563.75,
            CO2_alarm: 0,
            CO2_aqi: 20,
            SOC: 80,
            aqi: 20,
            humidity: 50,
            mslPressure: 982.5,
            pressure: 982.5,
            temperature: 21.35
        }
    },
    {
        date: 1668726000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -114.7376019773414,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -127.2376019773414,
            snr: -12.5
        },
        values: {
            CO2: 605,
            CO2_alarm: 0,
            CO2_aqi: 25,
            SOC: 80,
            aqi: 25,
            humidity: 50,
            mslPressure: 981.5,
            pressure: 981.5,
            temperature: 21.45
        }
    },
    {
        date: 1668718800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.39689615668325,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.64689615668325,
            snr: -10.25
        },
        values: {
            CO2: 677.5,
            CO2_alarm: 0,
            CO2_aqi: 30,
            SOC: 80,
            aqi: 30,
            humidity: 50,
            mslPressure: 980,
            pressure: 980,
            temperature: 21.55
        }
    },
    {
        date: 1668711600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -114.66249681577887,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -128.91249681577887,
            snr: -14.25
        },
        values: {
            CO2: 725,
            CO2_alarm: 0,
            CO2_aqi: 33,
            SOC: 80,
            aqi: 33,
            humidity: 50,
            mslPressure: 979,
            pressure: 979,
            temperature: 21.6
        }
    },
    {
        date: 1668704400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -111.3707776445072,
            port: 1,
            requested_nbrep: 1,
            rssi: -111,
            sf: 12,
            signal: -121.8707776445072,
            snr: -10.5
        },
        values: {
            CO2: 744,
            CO2_alarm: 0,
            CO2_aqi: 34,
            SOC: 80,
            aqi: 34,
            humidity: 50,
            mslPressure: 979,
            pressure: 979,
            temperature: 21.6
        }
    },
    {
        date: 1668697200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -115.21369319390936,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -128.21369319390936,
            snr: -13
        },
        values: {
            CO2: 667.1428571428571,
            CO2_alarm: 0,
            CO2_aqi: 29,
            SOC: 80,
            aqi: 29,
            humidity: 50,
            mslPressure: 978,
            pressure: 978,
            temperature: 21.4
        }
    },
    {
        date: 1668690000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 5.5,
            lora_version: 0,
            noise: -113.2516628666512,
            port: 1,
            requested_nbrep: 1,
            rssi: -113,
            sf: 12,
            signal: -125.5016628666512,
            snr: -12.25
        },
        values: {
            CO2: 651.25,
            CO2_alarm: 0,
            CO2_aqi: 28,
            SOC: 80,
            aqi: 28,
            humidity: 50,
            mslPressure: 979.5,
            pressure: 979.5,
            temperature: 21.2
        }
    },
    {
        date: 1668682800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1,
            lora_version: 0,
            noise: -115.2376019773414,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -127.7376019773414,
            snr: -12.5
        },
        values: {
            CO2: 614,
            CO2_alarm: 0,
            CO2_aqi: 26,
            SOC: 80,
            aqi: 26,
            humidity: 50,
            mslPressure: 980,
            pressure: 980,
            temperature: 21
        }
    },
    {
        date: 1668675600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -114.68680634183168,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -129.1868063418317,
            snr: -14.5
        },
        values: {
            CO2: 460,
            CO2_alarm: 0,
            CO2_aqi: 8,
            SOC: 80,
            aqi: 8,
            humidity: 50,
            mslPressure: 981,
            pressure: 981,
            temperature: 20.85
        }
    },
    {
        date: 1668668400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.46290884607976,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -128.46290884607976,
            snr: -13
        },
        values: {
            CO2: 480,
            CO2_alarm: 0,
            CO2_aqi: 10,
            SOC: 80,
            aqi: 10,
            humidity: 50,
            mslPressure: 980,
            pressure: 980,
            temperature: 21.5
        }
    },
    {
        date: 1668661200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.79408946035105,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -122.79408946035105,
            snr: -7
        },
        values: {
            CO2: 495,
            CO2_alarm: 0,
            CO2_aqi: 12,
            SOC: 80,
            aqi: 12,
            humidity: 50,
            mslPressure: 979,
            pressure: 979,
            temperature: 21.5
        }
    },
    {
        date: 1668654000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -114.38180330160682,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -125.38180330160682,
            snr: -11
        },
        values: {
            CO2: 516.25,
            CO2_alarm: 0,
            CO2_aqi: 15,
            SOC: 80,
            aqi: 15,
            humidity: 50,
            mslPressure: 979,
            pressure: 979,
            temperature: 21.5
        }
    },
    {
        date: 1668646800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 5,
            lora_version: 0,
            noise: -113.95030146848634,
            port: 1,
            requested_nbrep: 1,
            rssi: -113.5,
            sf: 12,
            signal: -124.45030146848634,
            snr: -10.5
        },
        values: {
            CO2: 547.5,
            CO2_alarm: 0,
            CO2_aqi: 18,
            SOC: 80,
            aqi: 18,
            humidity: 50,
            mslPressure: 979,
            pressure: 979,
            temperature: 21.6
        }
    },
    {
        date: 1668639600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3,
            lora_version: 0,
            noise: -115.39310310593942,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -126.14310310593942,
            snr: -10.75
        },
        values: {
            CO2: 585,
            CO2_alarm: 0,
            CO2_aqi: 23,
            SOC: 80,
            aqi: 23,
            humidity: 50,
            mslPressure: 979.5,
            pressure: 979.5,
            temperature: 21.75
        }
    },
    {
        date: 1668632400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1.5,
            lora_version: 0,
            noise: -115.71369319390936,
            port: 1,
            requested_nbrep: 1,
            rssi: -115.5,
            sf: 12,
            signal: -128.71369319390936,
            snr: -13
        },
        values: {
            CO2: 683.75,
            CO2_alarm: 0,
            CO2_aqi: 30,
            SOC: 80,
            aqi: 30,
            humidity: 50,
            mslPressure: 979.5,
            pressure: 979.5,
            temperature: 21.85
        }
    },
    {
        date: 1668625200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -114.78028102749226,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -126.78028102749226,
            snr: -12
        },
        values: {
            CO2: 778.75,
            CO2_alarm: 0,
            CO2_aqi: 36,
            SOC: 80,
            aqi: 36,
            humidity: 50,
            mslPressure: 980,
            pressure: 980,
            temperature: 22
        }
    },
    {
        date: 1668618000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -115.3707776445072,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.8707776445072,
            snr: -10.5
        },
        values: {
            CO2: 787.5,
            CO2_alarm: 0,
            CO2_aqi: 37,
            SOC: 80,
            aqi: 37,
            humidity: 50,
            mslPressure: 982,
            pressure: 982,
            temperature: 21.8
        }
    },
    {
        date: 1668610800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -114.26110020524963,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -126.76110020524963,
            snr: -12.5
        },
        values: {
            CO2: 782.5,
            CO2_alarm: 0,
            CO2_aqi: 36,
            SOC: 80,
            aqi: 36,
            humidity: 50,
            mslPressure: 982.5,
            pressure: 982.5,
            temperature: 21.6
        }
    },
    {
        date: 1668603600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2.5,
            lora_version: 0,
            noise: -114.43544191454478,
            port: 1,
            requested_nbrep: 1,
            rssi: -114,
            sf: 12,
            signal: -124.43544191454478,
            snr: -10
        },
        values: {
            CO2: 725,
            CO2_alarm: 0,
            CO2_aqi: 33,
            SOC: 80,
            aqi: 33,
            humidity: 50,
            mslPressure: 983.5,
            pressure: 983.5,
            temperature: 21.35
        }
    },
    {
        date: 1668596400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.55748118577408,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -125.05748118577408,
            snr: -9.5
        },
        values: {
            CO2: 531.25,
            CO2_alarm: 0,
            CO2_aqi: 16,
            SOC: 80,
            aqi: 16,
            humidity: 50,
            mslPressure: 985,
            pressure: 985,
            temperature: 20.75
        }
    },
    {
        date: 1668589200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4.5,
            lora_version: 0,
            noise: -115.19451237166673,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -128.69451237166675,
            snr: -13.5
        },
        values: {
            CO2: 525,
            CO2_alarm: 0,
            CO2_aqi: 16,
            SOC: 80,
            aqi: 16,
            humidity: 50,
            mslPressure: 985,
            pressure: 985,
            temperature: 20.85
        }
    },
    {
        date: 1668582000,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -115.97784640401417,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -121.97784640401417,
            snr: -6
        },
        values: {
            CO2: 538.75,
            CO2_alarm: 0,
            CO2_aqi: 17,
            SOC: 80,
            aqi: 17,
            humidity: 50,
            mslPressure: 985,
            pressure: 985,
            temperature: 21.5
        }
    },
    {
        date: 1668574800,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 1,
            lora_version: 0,
            noise: -115.72424220117267,
            port: 1,
            requested_nbrep: 1,
            rssi: -115.5,
            sf: 12,
            signal: -128.72424220117267,
            snr: -13
        },
        values: {
            CO2: 545,
            CO2_alarm: 0,
            CO2_aqi: 18,
            SOC: 80,
            aqi: 18,
            humidity: 50,
            mslPressure: 985,
            pressure: 985,
            temperature: 21.6
        }
    },
    {
        date: 1668567600,
        rawValues: {
            AppNonce: 0,
            CO2_error: 1,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 3.5,
            lora_version: 0,
            noise: -115.89031545675144,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -122.89031545675144,
            snr: -7
        },
        values: {
            CO2: 540,
            CO2_alarm: 0,
            CO2_aqi: 18,
            SOC: 80,
            aqi: 18,
            humidity: 50,
            mslPressure: 985,
            pressure: 985,
            temperature: 21.7
        }
    },
    {
        date: 1668560400,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 2,
            lora_version: 0,
            noise: -115.01782915310926,
            port: 1,
            requested_nbrep: 1,
            rssi: -114.5,
            sf: 12,
            signal: -124.01782915310926,
            snr: -9
        },
        values: {
            CO2: 558.75,
            CO2_alarm: 0,
            CO2_aqi: 20,
            SOC: 80,
            aqi: 20,
            humidity: 50,
            mslPressure: 984.5,
            pressure: 984.5,
            temperature: 21.85
        }
    },
    {
        date: 1668553200,
        rawValues: {
            AppNonce: 0,
            CO2_error: 0.5,
            DevAddr: 0,
            DevNonce: 1093,
            NetID: 7,
            battery: 3650,
            best_gateway_id: 0,
            gateways: 4,
            lora_version: 0,
            noise: -115.94630849637846,
            port: 1,
            requested_nbrep: 1,
            rssi: -115,
            sf: 12,
            signal: -122.44630849637846,
            snr: -6.5
        },
        values: {
            CO2: 613.75,
            CO2_alarm: 0,
            CO2_aqi: 26,
            SOC: 80,
            aqi: 26,
            humidity: 49.5,
            mslPressure: 984,
            pressure: 984,
            temperature: 22
        }
    }
]